const translations = {
  "en": {
    "Payment method updated.": "Payment method updated.",
    "We're updating your payment method…": "We're updating your payment method…"
  },
  "zh-tw": {
    "Payment method updated.": "付款方式已更新。",
    "We're updating your payment method…": "正在更新您的付款方式…"
  }
};

export default translations;
